type NextAvailableButtonProps = {
  loading: boolean
  onFind: () => Promise<void> | void
}

export default function NextAvailableButton({ loading, onFind }: NextAvailableButtonProps) {
  return (
    <button
      type="button"
      onClick={() => void onFind()}
      disabled={loading}
      className={`rounded-lg px-3 py-2 text-xs font-semibold ${
        loading
          ? 'border border-white/10 bg-white/10 text-white/50 cursor-not-allowed'
          : 'border border-white/15 bg-white/5 text-white hover:bg-white/10'
      }`}
    >
      {loading ? 'Finding...' : 'Next available'}
    </button>
  )
}
